import { kalturaPresentationInstruction } from "@/lib/scenarios/providers/kaltura/presentationTool";
import { screenShareInstruction } from "@/lib/scenarios/providers/kaltura/screenShare";

/**
 * Compose the directive Kaltura's intellect actually stores (`base_directive`).
 *
 * Capability flags alone don't reliably drive behaviour — the brain has to be
 * *told* that a document starts hidden behind a tool and that a shared screen
 * arrives as periodic stills, otherwise it answers "that feature isn't enabled"
 * even with the capability on.
 *
 * Single owner of that composition, because two code paths write the intellect:
 * the save pipeline and the session-start reconcile/repair in
 * `KalturaAgentFrame`. When the runtime path sent the trainer's raw prompt it
 * silently stripped these instructions from an intellect the save had composed
 * correctly.
 */
export function composeKalturaDirective(input: {
  /** The trainer's own prompt, as stored on the scenario block. */
  system_prompt?: string | null;
  present_document: boolean;
  /** The presented document is a PDF, so the paging tools are attached. */
  pageable: boolean;
  screen_share: boolean;
}): string {
  return [
    input.system_prompt?.trim(),
    input.present_document ? kalturaPresentationInstruction(input.pageable) : null,
    input.screen_share ? screenShareInstruction() : null,
  ]
    .filter(Boolean)
    .join("\n\n");
}
